const FEATURE_HELP_URLS = {
  agent_bots: 'https://ctcr.app/hc/agent-bots',
  agents: 'https://ctcr.app/hc/agents',
  audit_logs: 'https://ctcr.app/hc/audit-logs',
  campaigns: 'https://ctcr.app/hc/campaigns',
  canned_responses: 'https://ctcr.app/hc/canned',
  channel_email: 'https://ctcr.app/hc/email',
  channel_facebook: 'https://ctcr.app/hc/fb',
  custom_attributes: 'https://ctcr.app/hc/custom-attributes',
  dashboard_apps: 'https://ctcr.app/hc/dashboard-apps',
  help_center: 'https://ctcr.app/hc/help-center',
  inboxes: 'https://ctcr.app/hc/inboxes',
  integrations: 'https://ctcr.app/hc/integrations',
  labels: 'https://ctcr.app/hc/labels',
  macros: 'https://ctcr.app/hc/macros',
  message_reply_to: 'https://ctcr.app/hc/reply-to',
  reports: 'https://ctcr.app/hc/reports',
  sla: 'https://ctcr.app/hc/sla',
  team_management: 'https://ctcr.app/hc/teams',
  webhook: 'https://ctcr.app/hc/webhooks',
  billing: 'https://ctcr.app/pricing',
  saml: 'https://ctcr.app/hc/saml',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
